import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import adminAxios from './adminApi';
import { Loader2 } from 'lucide-react';

const ProtectedAdminRoute = ({ children }) => {
  const [status, setStatus] = useState('checking'); // checking | authed | unauthed

  useEffect(() => {
    const token = sessionStorage.getItem('hvac_admin_token');
    if (!token) {
      setStatus('unauthed');
      return;
    }
    adminAxios.get('/admin/me')
      .then(() => setStatus('authed'))
      .catch(() => setStatus('unauthed'));
  }, []);

  if (status === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="animate-spin text-blue-600" size={32} />
      </div>
    );
  }
  if (status === 'unauthed') return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedAdminRoute;
